import { useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Modal, Form, Title, Descriptions, Text } from '@bancobarigui/barihaus';

import { AssignForm } from './AssignForm';
import { RegisterFormButtons } from '@/components/RegisterFormButtons';

import { InspectionRequest } from '@/services/types/inspection.types';
import { useAssignInspectionModal } from './useAssignInspectionModal';

interface AssignInspectionModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  itemId?: string;
  inspectionData?: InspectionRequest | undefined;
}

export function AssignInspectionModal({
  open,
  onClose,
  onSuccess,
  itemId,
  inspectionData,
}: AssignInspectionModalProps) {
  const { form, isSubmitting, handleFormSubmit } = useAssignInspectionModal({
    itemId: itemId || '',
    onClose,
    onSuccess,
  });

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open, form]);

  if (!inspectionData || !itemId) return null;

  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleString('pt-BR');
  };

  // Verifica se é direcionamento inicial (status = 0 = AguardandoDirecionamento)
  const selectedItem = inspectionData.items?.find(item => item.id === itemId);
  const isInitialAssignment = selectedItem?.status === 0;

  return (
    <Modal
      centered
      open={open}
      width={900}
      footer={null}
      onCancel={onClose}
      className="space-y-8"
      closeIcon={<CloseOutlined />}
    >
      <div className="mb-6">
        <Title level={2}>DIRECIONAR INSPEÇÃO - #{inspectionData.proposalNumber}</Title>
      </div>

      <Descriptions
        column={{ xs: 1, sm: 2 }}
        bordered
        size="small"
        items={[
          {
            key: 'channel',
            label: <Text strong>Canal</Text>,
            children: inspectionData.channel || '-',
          },
          {
            key: 'orderNumber',
            label: <Text strong>Nº de Pedido</Text>,
            children: '-',
          },
          {
            key: 'proposalNumber',
            label: <Text strong>Nº de Proposta</Text>,
            children: inspectionData.proposalNumber || '-',
          },
          {
            key: 'createdAt',
            label: <Text strong>Solicitação</Text>,
            children: formatDate(inspectionData.createdAt),
          },
        ]}
      />

      <div className="mt-6">
        <Title level={4}>Informações de Direcionamento</Title>
        <Text className="block mb-4">
          Defina o destinatário para qual a inspeção será direcionada. Você também poderá adicionar
          uma nota de direcionamento.
        </Text>

        <Form form={form} layout="vertical" onFinish={handleFormSubmit} className="mt-4">
          <AssignForm form={form} isInitialAssignment={isInitialAssignment} />

          <RegisterFormButtons onClickCancel={onClose} loading={isSubmitting} />
        </Form>
      </div>
    </Modal>
  );
}
